import { Fragment, useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/public-notices/PublicNoticesAction";
import { downloadErrorAlert, redirectToPages, saveAsFile } from "../../../../../../_helpers/Helpers";
import { useSubheader } from "../../../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";

export function PublicNoticeDetail({
  match: {
    params: { id }
  }
}) {
  // Subheader
  const subheader = useSubheader();
  const [title, setTitle] = useState("");
  
  // Getting curret state of Public Notice Details from store (Redux)
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, publicNotice } = useSelector(
    (state) => ({
      actionsLoading: state.publicNotices.actionsLoading,
      isSuccess: state.publicNotices.isSuccess,
      type: state.publicNotices.type,
      publicNotice: state.publicNotices.publicNotice
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getPublicNotice(id));
    return () => dispatch(actions.cleanPublicNoticesState());
  }, [id, dispatch]);
  
  useEffect(() => {
    let _title = "Genel Duyuru Detayı";
    setTitle(_title);
    subheader.setTitle(_title);
  }, [subheader]);
    
  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  /** Belli Bir Eki İndirir */
  const downloadAttachment = (id, filename) => {
    dispatch(actions.downloadAttachment(id)).then(file => {
      if (!file) {
        downloadErrorAlert();
        return;
      }
      saveAsFile(file, filename);
    });
  }

  const expArr = publicNotice.explanation.split("\n");

  return (
    <Card>
      { actionsLoading && <ModalProgressBar /> }
      <CardHeader title={title} />
      <CardBody>
        <div className="form-group row">
          <div className="col-2">
            <b>Gönderen:</b>
          </div>
          <div className="col-10">
            {publicNotice.sender}
          </div>            
        </div>

        <div className="form-group row">
          <div className="col-2">
            <b>Tarih:</b>
          </div>
          <div className="col-10">
            {publicNotice.createDate}
          </div>
        </div>

        <div className="form-group row">
          <div className="col-2">
            <b>Tanımı:</b>
          </div>
          <div className="col-10">
            {publicNotice.definition}
          </div>
        </div>
        
        <div className="form-group row">
          <div className="col-2">
            <b>Açıklaması:</b>
          </div>
          <div className="col-10">
            {
              expArr.map((explanation, i) => (
                <Fragment key={i}>
                  {explanation}
                  {i !== expArr.length - 1 && <br />}
                </Fragment>
              ))
            }
          </div>
        </div>

        {
          publicNotice.attachmentName &&
          <div className="form-group row">
            <div className="col-2">
              <b>Ek:</b>
            </div>
            <div className="col-10">
              <a href="javascript:" onClick={() => downloadAttachment(id, publicNotice.attachmentName)}>{publicNotice.attachmentName}</a>
            </div>
          </div>
        }

        <div className="form-group row">
          <div className="col-2">
            <b>Gönderim Türü:</b>
          </div>
          <div className="col-10">
            {publicNotice.sendingType}
          </div>
        </div>

        <div className="form-group row">
          <div className="col-2">
            <b>Durum:</b>
          </div>
          <div className="col-10">
            {
              publicNotice.isSent !== undefined &&
              <span className={`label label-lg label-light-${publicNotice.isSent ? "success" : "danger"} label-inline`}>{publicNotice.isSent ? "Gönderildi" : "Beklemede"}</span>
            }            
          </div>
        </div>
      </CardBody>
    </Card>
  );
}